export default "__VITE_ASSET__CspUD08L__"